import React, { useState, useEffect, useMemo } from "react";
import {
  Button,
  Container,
  Grid,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Typography,
} from "@material-ui/core";
import HomePage from "../../Home";
import { VUsuariosStyle } from "./styles";
import TUsuarios from "./../TUsuarios";
import FUsuario from "./../FUsuarios";
import { useDispatch, useSelector } from "react-redux";
import { obtenerUsuariosAction } from "../../../ducks/usuariosDuck";
import BackDrop from "./../../../global/BackDrop";
import useApi from "./../../../hooks/useAPI";

const EST_FILTRO_TODOS = "todos";
const EST_FILTRO_ACTIVO = "activo";
const EST_FILTRO_INACTIVO = "inactivo";

function usuarioCoincideEstatus(estatus, filtro) {
  if (filtro === EST_FILTRO_TODOS) return true;
  const activo = estatus === true || estatus === 1;
  if (filtro === EST_FILTRO_ACTIVO) return activo;
  return !activo;
}

export default function VProveedorUsuario() {
  const Clasess = VUsuariosStyle();
  const dispatch = useDispatch();
  const catalogoTipoUsuario = useApi("Catalog/TipoUsuario");
  const usuarios = useSelector(
    (store) => store.usuarios.array
  );
  
  const [openModal, setOpenModal] = useState(false);
  const [rowTarget, setRowTarget] = useState({});
  const [editar, setEditar] = useState(false);
  const [isLoad, setIsLoad] = useState(false);
  const [tipoUsuario, setTipoUsuario] = useState(0);
  const [filtroEstatus, setFiltroEstatus] = useState(EST_FILTRO_TODOS);

  const usuariosFiltrados = useMemo(
    () =>
      (usuarios || []).filter((u) =>
        usuarioCoincideEstatus(u?.Informacion?.Estatus, filtroEstatus)
      ),
    [usuarios, filtroEstatus]
  );

  useEffect(() => {
    setIsLoad(true);
    dispatch(obtenerUsuariosAction(tipoUsuario)).then((Reposne) => {
      setIsLoad(false);
    });
  }, [dispatch, tipoUsuario]);

  const handleOpen = () => {
    setOpenModal(!openModal);
    setEditar(false);
  };

  const onEditar = (rowTarget) => {
    setRowTarget(rowTarget);
    setEditar(true);
    setOpenModal(!openModal);
  };

  const handleSelecTipoUsuario = (event) =>{
    setTipoUsuario(event.target.value);
  };

  const handleSelectEstatus = (event) => {
    setFiltroEstatus(event.target.value);
  };
  
  return (
    <HomePage>
      <Container maxWidth={false} className={Clasess.pageRoot}>
        <Typography variant="h5" component="h1" className={Clasess.title}>
          Usuarios de sistema
        </Typography>
        <Grid
          container
          direction="row"
          justifyContent="space-between"
          alignItems="center"
          spacing={2}
          className={`${Clasess.contentMargin} ${Clasess.filterRow}`}
        >
          <Grid item xs={12} sm={4} md={3}>
          <FormControl variant="outlined" className={Clasess.formControl}>
              <InputLabel id="lTipoUsuario">Tipo Usuario</InputLabel>
              <Select
                labelId="lTipoUsuario"
                id="STipoUsuario"
                name="tipoUsuario"
                value={tipoUsuario}
                onChange={handleSelecTipoUsuario}
                label="Tipo Usuario"
              >
                <MenuItem value={0}>
                  {"Todos los usuarios"}
                </MenuItem>
                {catalogoTipoUsuario.map((item, index) => (
                  <MenuItem key={item.IdTipoUsuario} value={item.IdTipoUsuario}>
                    {item.Descripion}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12} sm={4} md={3}>
            <FormControl variant="outlined" className={Clasess.formControl}>
              <InputLabel id="lEstatus">Estatus</InputLabel>
              <Select
                labelId="lEstatus"
                id="SEstatus"
                name="estatus"
                value={filtroEstatus}
                onChange={handleSelectEstatus}
                label="Estatus"
              >
                <MenuItem value={EST_FILTRO_TODOS}>Todos</MenuItem>
                <MenuItem value={EST_FILTRO_ACTIVO}>Activos</MenuItem>
                <MenuItem value={EST_FILTRO_INACTIVO}>Inactivos</MenuItem>
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12} sm={4} md={3} className={Clasess.flexEnd}>
            <Button variant="outlined" color="primary" onClick={handleOpen}>
              Nuevo usuario
            </Button>
          </Grid>
        </Grid>
        <div className={Clasess.tableSection}>
          <TUsuarios rows={usuariosFiltrados} onEditar={onEditar} />
        </div>
        <FUsuario
          open={openModal}
          setOpen={setOpenModal}
          editar={editar}
          setEditar={setEditar}
          rowData={rowTarget}
        />
        <BackDrop open={isLoad} />
      </Container>
    </HomePage>
  );
}
